import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-network-eco-page',
  templateUrl: './network-eco-page.component.html',
  styleUrls: ['./network-eco-page.component.css'],
})
export class NetworkEcoPageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.networkSave;
  private getApi = environment.url + environment.networkGet;
  /**
   * Constructor to initialize the NetworkEcoPageComponent.
   * Sets up the form group with various form controls for different questions.
   * Initializes the media query listener.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    // Initialize the settings form with form controls for each question
    this.settingsForm = this.fb.group({
      // Question 001: Local Startup Ecosystem
      localStartupEcosystemIncCentre: [''],
      localStartupEcosystemDocuments: new FormArray([]),
      localStartupEcosystemNoOfLocalBody: [''],
      localStartupEcosystemImagefile: [''],
      localStartupEcosystemStatus: [''],

      // Question 002: Networking Platform
      networkingPlatformIncCentre: [''],
      networkingPlatformDocuments: new FormArray([]),
      networkingPlatformUrlIcWebsite: [''],
      networkingPlatformImagefile: [''],
      networkingPlatformNoOfLocalBody: [''],
      networkingPlatformStatus: [''],

      // Question 003: Programs Conducted
      programsConductedIncCentre: [''],
      programsConductedDocuments: new FormArray([]),
      programsConductedImagefile: [''],
      programsConductedNoOfPrograms: [''],
      programsConductedStatus: [''],

      // Question 004: Hosting Local Entrepreneurs
      hostingLocalEntrepreneursIncCentre: [''],
      hostingLocalEntrepreneursDocuments: new FormArray([]),
      hostingLocalEntrepreneursImagefile: [''],
      hostingLocalEntrepreneursNoOfPrograms: [''],
      hostingLocalEntrepreneursStatus: [''],

      // Question 005: Platform For Startups
      platformForStartupsIncCentre: [''],
      platformForStartupsDocuments: new FormArray([]),
      platformForStartupsImagefile: [''],
      platformForStartupsStatus: [''],

      // Question 006: Student Entrepreneurs
      studentEntrepreneursIncCentre: [''],
      studentEntrepreneursDocuments: new FormArray([]),
      studentEntrepreneursImagefile: [''],
      studentEntrepreneursNoOfStudents: [''],
      studentEntrepreneursStatus: [''],

      // Question 007: Academic Financial Institutions
      academicFinancialInstitutionsIncCentre: [''],
      academicFinancialInstitutionsDocuments: new FormArray([]),
      academicFinancialInstitutionsImagefile: [''],
      academicFinancialInstitutionsNoOfFacilitator: [''],
      academicFinancialInstitutionsStatus: [''],

      // Question 009: Facilitation Of Incubated
      facilitationOfIncubatedIncCentre: [''],
      facilitationOfIncubatedDocuments: new FormArray([]),
      facilitationOfIncubatedImagefile: [''],
      facilitationOfIncubatedNoOfNationalExpo: [''],
      facilitationOfIncubatedNoOfInternationalExpo: [''],
      facilitationOfIncubatedStatus: [''],

      // New Question: Database of People Etc.
      databaseofPeopleEtcPresent: [''],
      databaseofPeopleEtcDocuments: new FormArray([]),
      databaseofPeopleEtcUrlIcWebsite: [''],
      databaseofPeopleEtcImagefile: [''],
      databaseofPeopleEtcStatus: [''],

      // New Question: Conduct Local Community
      conductLocalCommunityPresent: [''],
      conductLocalCommunityDocuments: new FormArray([]),
      conductLocalCommunityImagefile: [''],
      conductLocalCommunityNoOfPrograms: [''],
      conductLocalCommunityStatus: [''],

      // New Question: Meet & Greet Sessions
      meetGreetSessionsPresent: [''],
      meetGreetSessionsDocuments: new FormArray([]),
      meetGreetSessionsImagefile: [''],
      meetGreetSessionsNoOfPrograms: [''],
      meetGreetSessionsStatus: [''],

      // New Question: Strategic Alliance
      strategicAlliancePresent: [''],
      strategicAllianceDocuments: new FormArray([]),
      strategicAllianceImagefile: [''],
      strategicAllianceNoOfAlliances: [''],
      strategicAllianceStatus: [''],
    });

    // Set up media query listener
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.settingsForm.controls;
  }
  ngOnInit(): void {
    this.getPush();
    this.getDataApi();
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches network ecosystem data for the current user from the API and updates the form and UI accordingly.
   *
   * - Shows a loading indicator while fetching data.
   * - Retrieves user-specific network ecosystem data using the stored user ID.
   * - If the response is successful, patches the form with the received data.
   * - For each option marked as 'Yes' in the response, displays the corresponding UI options.
   * - Loads and displays associated documents for each option, updating the UI to reflect successful uploads.
   * - Handles UI updates using jQuery to show/hide upload and remove wrappers with success indicators.
   * - Hides the loading indicator after processing is complete.
   */
  getDataApi() {
    // Display loader while fetching data
    this.getdata.amizhthLoader('show');

    // Make API request to fetch network ecosystem data
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        // Hide loader after data is fetched
        this.getdata.amizhthLoader('hide');

        this.getValue = data;

        if (data.responseStatus != 'Failed') {
          // Update form with fetched data
          this.settingsForm.patchValue(data);

          // Check each condition and display corresponding options
          if (data.localStartupEcosystemIncCentre == 'Yes') {
            this.showOptionsone('Yes', '.upload0', 0, '.set-succ0');
          }
          if (data.networkingPlatformIncCentre == 'Yes') {
            this.showOptionstwo('Yes', '.upload1', 1, '.set-succ1');
          }
          if (data.programsConductedIncCentre == 'Yes') {
            this.showOptionsthree('Yes', '.upload2', 2, '.set-succ2');
          }
          if (data.hostingLocalEntrepreneursIncCentre == 'Yes') {
            this.showOptionsfour('Yes', '.upload3', 3, '.set-succ3');
          }
          if (data.platformForStartupsIncCentre == 'Yes') {
            this.showOptionsfive('Yes', '.upload4', 4, '.set-succ4');
          }
          if (data.studentEntrepreneursIncCentre == 'Yes') {
            this.showOptionssix('Yes', '.upload5', 5, '.set-succ5');
          }
          if (data.academicFinancialInstitutionsIncCentre == 'Yes') {
            this.showOptionsseven('Yes', '.upload6', 6, '.set-succ6');
          }
          if (data.externalMembersIncCentre == 'Yes') {
            this.showOptions8('Yes', '.upload7', 7, '.set-succ7');
          }
          if (data.facilitationOfIncubatedIncCentre == 'Yes') {
            this.showOptions9('Yes', '.upload8', 8, '.set-succ8');
          }
          if (data.databaseofPeopleEtcPresent == 'Yes') {
            this.showOptions10('Yes', '.upload9', 9, '.set-succ9');
          }
          if (data.conductLocalCommunityPresent == 'Yes') {
            this.showOptions11('Yes', '.upload10', 10, '.set-succ10');
          }
          if (data.meetGreetSessionsPresent == 'Yes') {
            this.showOptions12('Yes', '.upload11', 11, '.set-succ11');
          }
          if (data.strategicAlliancePresent == 'Yes') {
            this.showOptions13('Yes', '.upload12', 12, '.set-succ12');
          }

          // Get the current form values
          let getform = this.settingsForm.value;

          // Load and display documents for each condition
          this.loadDocuments(data, getform, 'localStartupEcosystem', 0);
          this.loadDocuments(data, getform, 'networkingPlatform', 1);
          this.loadDocuments(data, getform, 'programsConducted', 2);
          this.loadDocuments(data, getform, 'hostingLocalEntrepreneurs', 3);
          this.loadDocuments(data, getform, 'platformForStartups', 4);
          this.loadDocuments(data, getform, 'studentEntrepreneurs', 5);
          this.loadDocuments(data, getform, 'academicFinancialInstitutions', 6);
          this.loadDocuments(data, getform, 'externalMembers', 7);
          this.loadDocuments(data, getform, 'facilitationOfIncubated', 8);
          this.loadDocuments(data, getform, 'databaseofPeopleEtc', 9);
          this.loadDocuments(data, getform, 'conductLocalCommunity', 10);
          this.loadDocuments(data, getform, 'meetGreetSessions', 11);
          this.loadDocuments(data, getform, 'strategicAlliance', 12);

          // Update form with modified values
          this.settingsForm.patchValue(getform);
        }
      });
  }

  /**
   * Loads and displays documents for a specific category.
   *
   * @param data - The data object containing document information.
   * @param getform - The current form values.
   * @param category - The category name for which the documents are being loaded.
   * @param index - The index to update the documentValues array.
   */
  private loadDocuments(
    data: any,
    getform: any,
    category: string,
    index: number
  ) {
    const documentsKey = `${category}Documents`;
    const imageFileKey = `${category}Imagefile`;

    if (data[documentsKey] != '' && data[documentsKey] != undefined) {
      this.documentValues[index] = data[documentsKey];
      getform[imageFileKey] = data[documentsKey][0].documentFile;

      setTimeout(() => {
        $(`.set-succ${index}`).addClass('success');
        $(`.upload-wrapper.upload${index}`).addClass('d-none');
        $(`.upload-wrapper.upload${index}`).removeClass('success');
        $(`.remove-wrapper.upload${index}`).addClass('d-flex active');
      }, 5000);
    }
  }

  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  viewReasonBtn(status) {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  setStatus(event, key, value) {
    this.settingsForm.controls[key].setValue(value);
  }
  getPush() {
    for (let i = 0; i < 13; i++) {
      let req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      this.documentValues.push(req);
    }
  }
  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  /**
   * Handles file upload events, processes selected files, updates form controls, and UI states.
   * Accepts only jpeg, jpg, png, and pdf files.
   *
   * @param event - The file input change event.
   * @param val - A value used for UI selector construction.
   * @param i - Index indicating which document/form control to update.
   * @param set - Selector or reference for additional UI updates.
   */
  fileUpload(event, val, i, set) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const reader = new FileReader();
      const imagetype = this.selecetdFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Check if the file type is one of the allowed types
      if (['jpeg', 'jpg', 'png', 'pdf'].includes(img_crt_type)) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          // Process and split the base64 data
          this.url = reader.result;
          const spl = this.url.split(',');

          // Update document values with the file data
          const val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;

          // Update form controls based on the index
          const controlMap = [
            'localStartupEcosystem',
            'networkingPlatform',
            'programsConducted',
            'hostingLocalEntrepreneurs',
            'platformForStartups',
            'studentEntrepreneurs',
            'academicFinancialInstitutions',
            'externalMembers',
            'facilitationOfIncubated',
            'databaseofPeopleEtc',
            'conductLocalCommunity',
            'meetGreetSessions',
            'strategicAlliance',
          ];

          if (controlMap[i]) {
            this.settingsForm.controls[`${controlMap[i]}Status`].setValue(7);
            this.settingsForm.controls[`${controlMap[i]}Imagefile`].setValue(
              this.selecetdFile.name
            );
          }
        };

        // UI feedback for successful upload
        setTimeout(() => {
          const datass = '.upload-wrapper' + val;
          $(datass).addClass('uploaded');
        }, 600);

        setTimeout(() => {
          const datas = '.upload-wrapper' + val;
          $(datas).removeClass('uploaded').addClass('success');
          $(set).addClass('success');
        }, 1600);

        setTimeout(() => {
          const datas = '.upload-wrapper' + val;
          $(datas).addClass('d-none').removeClass('success');
          const data = '.remove-wrapper' + val;
          $(data).addClass('d-flex active');
        }, 5000);
      } else {
        // Notify user of invalid file format
        this.notify.notifyError(
          'Only jpeg, jpg, png, and pdf format images are allowed'
        );
      }
    }
  }
  /**
   * Removes the uploaded file and resets the form controls for the corresponding question.
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  removeFile(val, i, set) {
    // Reset the uploaded file and filename
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';

    // Remove the uploaded file and reset the form controls
    setTimeout(function () {
      let datass = '.upload-wrapper' + val;
      $(datass).removeClass('d-none');
      let data = '.remove-wrapper' + val;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');
      $(set).removeClass('success');
    }, 1000);

    // Reset the status and imagefile for the corresponding question
    switch (i) {
      case 0:
        this.settingsForm.controls['localStartupEcosystemStatus'].setValue(1);
        this.settingsForm.controls['localStartupEcosystemImagefile'].setValue(
          ''
        );
        break;
      case 1:
        this.settingsForm.controls['networkingPlatformStatus'].setValue(1);
        this.settingsForm.controls['networkingPlatformImagefile'].setValue('');
        break;
      case 2:
        this.settingsForm.controls['programsConductedStatus'].setValue(1);
        this.settingsForm.controls['programsConductedImagefile'].setValue('');
        break;
      case 3:
        this.settingsForm.controls['hostingLocalEntrepreneursStatus'].setValue(
          1
        );
        this.settingsForm.controls[
          'hostingLocalEntrepreneursImagefile'
        ].setValue('');
        break;
      case 4:
        this.settingsForm.controls['platformForStartupsStatus'].setValue(1);
        this.settingsForm.controls['platformForStartupsImagefile'].setValue('');
        break;
      case 5:
        this.settingsForm.controls['studentEntrepreneursStatus'].setValue(1);
        this.settingsForm.controls['studentEntrepreneursImagefile'].setValue(
          ''
        );
        break;
      case 6:
        this.settingsForm.controls[
          'academicFinancialInstitutionsStatus'
        ].setValue(1);
        this.settingsForm.controls[
          'academicFinancialInstitutionsImagefile'
        ].setValue('');
        break;
      case 7:
        this.settingsForm.controls['externalMembersStatus'].setValue(1);
        this.settingsForm.controls['externalMembersImagefile'].setValue('');
        break;
      case 8:
        this.settingsForm.controls['facilitationOfIncubatedStatus'].setValue(1);
        this.settingsForm.controls['facilitationOfIncubatedImagefile'].setValue(
          ''
        );
        break;
      // new 5th qus
      case 9:
        this.settingsForm.controls['databaseofPeopleEtcStatus'].setValue(1);
        this.settingsForm.controls['databaseofPeopleEtcImagefile'].setValue('');
        break;
      // new 6th qus
      case 10:
        this.settingsForm.controls['conductLocalCommunityStatus'].setValue(1);
        this.settingsForm.controls['conductLocalCommunityImagefile'].setValue(
          ''
        );
        break;
      // new 7th qus
      case 11:
        this.settingsForm.controls['meetGreetSessionsStatus'].setValue(1);
        this.settingsForm.controls['meetGreetSessionsImagefile'].setValue('');
        break;
      // new 9th qus
      case 12:
        this.settingsForm.controls['strategicAllianceStatus'].setValue(1);
        this.settingsForm.controls['strategicAllianceImagefile'].setValue('');
        break;
    }
  }
  Optionsonechecked = '';
  /**
   * Handles the change event for the local startup ecosystem option.
   * Updates form controls based on the selected option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsone(event, val, i, set) {
    // Update the checked value of the Optionsonechecked variable
    this.Optionsonechecked = event;
    if (event == 'No') {
      // If "No" is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      // Clear the no of local body value and validators
      this.settingsForm.controls['localStartupEcosystemNoOfLocalBody'].setValue(
        null
      );
      this.settingsForm.controls[
        'localStartupEcosystemNoOfLocalBody'
      ].clearValidators();
      // Clear the image file value and validators
      this.settingsForm.controls['localStartupEcosystemImagefile'].setValue('');
      this.settingsForm.controls[
        'localStartupEcosystemImagefile'
      ].clearValidators();
    } else {
      // If "Yes" is selected, set required validators for no of local body and image file controls
      this.settingsForm.controls[
        'localStartupEcosystemNoOfLocalBody'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'localStartupEcosystemImagefile'
      ].setValidators([Validators.required]);
    }
    // Update validity of form controls
    this.settingsForm.controls[
      'localStartupEcosystemNoOfLocalBody'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'localStartupEcosystemImagefile'
    ].updateValueAndValidity();
  }
  Optionstwochecked = '';
  /**
   * Handles the change event for the programs conducted option.
   * Updates form controls based on the selected option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionstwo(event, val, i, set) {
    // Update the checked value of the Optionstwochecked variable
    this.Optionstwochecked = event;
    if (event === 'No') {
      // Clear the no of programs value and validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['networkingPlatformNoOfLocalBody'].setValue(
        null
      );
      this.settingsForm.controls[
        'networkingPlatformNoOfLocalBody'
      ].clearValidators();
      // Clear the url and image file values and validators
      this.settingsForm.controls['networkingPlatformUrlIcWebsite'].setValue('');
      this.settingsForm.controls['networkingPlatformImagefile'].setValue('');
      this.settingsForm.controls[
        'networkingPlatformUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls[
        'networkingPlatformImagefile'
      ].clearValidators();
    } else {
      // Set required validators for url and image file controls
      this.settingsForm.controls[
        'networkingPlatformUrlIcWebsite'
      ].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls['networkingPlatformImagefile'].setValidators([
        Validators.required,
      ]);
      // Set required validator for no of programs control
      this.settingsForm.controls[
        'networkingPlatformNoOfLocalBody'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the controls
    this.settingsForm.controls[
      'networkingPlatformUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'networkingPlatformImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'networkingPlatformNoOfLocalBody'
    ].updateValueAndValidity();
  }
  Optionsthreechecked = '';
  /**
   * Handles the change event for the programs conducted option.
   * Updates form controls based on the selected option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsthree(event, val, i, set) {
    // Update the checked value of the Optionsthreechecked variable
    this.Optionsthreechecked = event;
    if (event === 'No') {
      // Clear the no of programs value and validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['programsConductedNoOfPrograms'].setValue(
        null
      );
      this.settingsForm.controls[
        'programsConductedNoOfPrograms'
      ].clearValidators();
      // Clear the image file value and validators
      this.settingsForm.controls['programsConductedImagefile'].setValue('');
      this.settingsForm.controls[
        'programsConductedImagefile'
      ].clearValidators();
    } else {
      // Set the no of programs required validator
      this.settingsForm.controls['programsConductedNoOfPrograms'].setValidators(
        [Validators.required]
      );
      // Set the image file required validator
      this.settingsForm.controls['programsConductedImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the form controls validity
    this.settingsForm.controls[
      'programsConductedNoOfPrograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'programsConductedImagefile'
    ].updateValueAndValidity();
  }
  Optionsfourchecked = '';
  /**
   * Handles the change event for the hosting local entrepreneurs option.
   * Updates form controls based on the selected option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsfour(event, val, i, set) {
    // Store the selected option
    this.Optionsfourchecked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls[
        'hostingLocalEntrepreneursNoOfPrograms'
      ].setValue(null);
      this.settingsForm.controls[
        'hostingLocalEntrepreneursNoOfPrograms'
      ].clearValidators();
      this.settingsForm.controls['hostingLocalEntrepreneursImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'hostingLocalEntrepreneursImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set validators for required fields
      this.settingsForm.controls[
        'hostingLocalEntrepreneursNoOfPrograms'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'hostingLocalEntrepreneursImagefile'
      ].setValidators([Validators.required]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'hostingLocalEntrepreneursNoOfPrograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'hostingLocalEntrepreneursImagefile'
    ].updateValueAndValidity();
  }
  Optionsfivechecked = '';
  /**
   * Updates form controls based on the selected option for platform for startups.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsfive(event: string, val: string, i: number, set: string) {
    this.Optionsfivechecked = event;
    if (event === 'No') {
      // Remove the associated file and clear validators for 'No' selection
      this.removeFile(val, i, set);
      this.settingsForm.controls['platformForStartupsImagefile'].setValue(null);
      this.settingsForm.controls[
        'platformForStartupsImagefile'
      ].clearValidators();
    } else {
      // Set validators for 'Yes' selection
      this.settingsForm.controls['platformForStartupsImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update validity of the form control
    this.settingsForm.controls[
      'platformForStartupsImagefile'
    ].updateValueAndValidity();
  }
  Optionssixchecked = '';
  /**
   * Updates form controls based on the selected option for student entrepreneurs.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionssix(event, val, i, set) {
    this.Optionssixchecked = event;
    if (event == 'No') {
      // Remove the associated file and clear validators for 'No' selection
      this.removeFile(val, i, set);
      this.settingsForm.controls['studentEntrepreneursNoOfStudents'].setValue(
        null
      );
      this.settingsForm.controls[
        'studentEntrepreneursNoOfStudents'
      ].clearValidators();
      this.settingsForm.controls['studentEntrepreneursImagefile'].setValue('');
      this.settingsForm.controls[
        'studentEntrepreneursImagefile'
      ].clearValidators();
    } else {
      // Set validators for required fields when 'Yes' is selected
      this.settingsForm.controls[
        'studentEntrepreneursNoOfStudents'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['studentEntrepreneursImagefile'].setValidators(
        [Validators.required]
      );
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'studentEntrepreneursNoOfStudents'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'studentEntrepreneursImagefile'
    ].updateValueAndValidity();
  }
  Optionssevenchecked = '';
  /**
   * Handles the change event for the "Academic Financial Institutions" options.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsseven(event, val, i, set) {
    this.Optionssevenchecked = event;

    // If 'No' is selected, clear values and validators
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls[
        'academicFinancialInstitutionsNoOfFacilitator'
      ].setValue(null);
      this.settingsForm.controls[
        'academicFinancialInstitutionsNoOfFacilitator'
      ].clearValidators();
      this.settingsForm.controls[
        'academicFinancialInstitutionsImagefile'
      ].setValue('');
      this.settingsForm.controls[
        'academicFinancialInstitutionsImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators
      this.settingsForm.controls[
        'academicFinancialInstitutionsNoOfFacilitator'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'academicFinancialInstitutionsImagefile'
      ].setValidators([Validators.required]);
    }

    // Update validity of form controls
    this.settingsForm.controls[
      'academicFinancialInstitutionsNoOfFacilitator'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'academicFinancialInstitutionsImagefile'
    ].updateValueAndValidity();
  }
  Options8checked = '';
  /**
   * Handles the change event for the "External Members" options.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions8(event, val, i, set) {
    this.Options8checked = event;

    // If 'No' is selected, clear values and validators
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['externalMembersNoOfMember'].setValue(null);
      this.settingsForm.controls['externalMembersNoOfMember'].clearValidators();
      this.settingsForm.controls['externalMembersImagefile'].setValue('');
      this.settingsForm.controls['externalMembersImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators
      this.settingsForm.controls['externalMembersNoOfMember'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['externalMembersImagefile'].setValidators([
        Validators.required,
      ]);
    }

    // Update validity of form controls
    this.settingsForm.controls[
      'externalMembersNoOfMember'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'externalMembersImagefile'
    ].updateValueAndValidity();
  }
  Options9checked = '';
  /**
   * Handles the change event for the "Facilitation of Incubated" options.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions9(event, val, i, set) {
    this.Options9checked = event;

    // If 'No' is selected, clear values and validators
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls[
        'facilitationOfIncubatedNoOfNationalExpo'
      ].setValue(null);
      this.settingsForm.controls[
        'facilitationOfIncubatedNoOfNationalExpo'
      ].clearValidators();
      this.settingsForm.controls[
        'facilitationOfIncubatedNoOfInternationalExpo'
      ].setValue(null);
      this.settingsForm.controls[
        'facilitationOfIncubatedNoOfInternationalExpo'
      ].clearValidators();
      this.settingsForm.controls['facilitationOfIncubatedImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'facilitationOfIncubatedImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators
      this.settingsForm.controls[
        'facilitationOfIncubatedImagefile'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'facilitationOfIncubatedNoOfNationalExpo'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'facilitationOfIncubatedNoOfInternationalExpo'
      ].setValidators([Validators.required]);
    }

    // Update validity of form controls
    this.settingsForm.controls[
      'facilitationOfIncubatedImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'facilitationOfIncubatedNoOfNationalExpo'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'facilitationOfIncubatedNoOfInternationalExpo'
    ].updateValueAndValidity();
  }

  // new 5th qus
  Options10checked = '';
  /**
   * Handles the change event for the "Database of People etc." option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions10(event: string, val: string, i: number, set: string) {
    this.Options10checked = event;
    if (event == 'No') {
      // If "No" is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['databaseofPeopleEtcUrlIcWebsite'].setValue(
        ''
      );
      this.settingsForm.controls['databaseofPeopleEtcImagefile'].setValue('');
      this.settingsForm.controls[
        'databaseofPeopleEtcUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls[
        'databaseofPeopleEtcImagefile'
      ].clearValidators();
    } else {
      // If "Yes" is selected, set required validators
      this.settingsForm.controls[
        'databaseofPeopleEtcUrlIcWebsite'
      ].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls['databaseofPeopleEtcImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update validity of form controls
    this.settingsForm.controls[
      'databaseofPeopleEtcUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'databaseofPeopleEtcImagefile'
    ].updateValueAndValidity();
  }
  // new 6th qus
  Options11checked = '';
  /**
   * Handles the change event for the "Conduct Local Community" option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions11(event, val, i, set) {
    this.Options11checked = event;
    if (event == 'No') {
      // If "No" is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['conductLocalCommunityNoOfPrograms'].setValue(
        ''
      );
      this.settingsForm.controls['conductLocalCommunityImagefile'].setValue('');
      this.settingsForm.controls[
        'conductLocalCommunityNoOfPrograms'
      ].clearValidators();
      this.settingsForm.controls[
        'conductLocalCommunityImagefile'
      ].clearValidators();
    } else {
      // If "Yes" is selected, set required validators
      this.settingsForm.controls[
        'conductLocalCommunityNoOfPrograms'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'conductLocalCommunityImagefile'
      ].setValidators([Validators.required]);
    }
    // Update validity of form controls
    this.settingsForm.controls[
      'conductLocalCommunityNoOfPrograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'conductLocalCommunityImagefile'
    ].updateValueAndValidity();
  }
  // new 7th qus
  Options12checked = '';
  /**
   * Handles the change event of the "Has the institution organized meet and greet sessions with the industry partners" question.
   * @param event The change event.
   * @param val The value of the question.
   * @param i The index of the question in the form array.
   * @param set The form control for the question.
   */
  showOptions12(event, val, i, set) {
    this.Options12checked = event;
    if (event == 'No') {
      // If the user selects "No", remove the file and clear the validators.
      this.removeFile(val, i, set);
      this.settingsForm.controls['meetGreetSessionsNoOfPrograms'].setValue('');
      this.settingsForm.controls['meetGreetSessionsImagefile'].setValue('');
      this.settingsForm.controls[
        'meetGreetSessionsNoOfPrograms'
      ].clearValidators();
      this.settingsForm.controls[
        'meetGreetSessionsImagefile'
      ].clearValidators();
    } else {
      // If the user selects "Yes", set the validators for the number of programs and the image file.
      this.settingsForm.controls['meetGreetSessionsNoOfPrograms'].setValidators(
        [Validators.required]
      );
      this.settingsForm.controls['meetGreetSessionsImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the controls.
    this.settingsForm.controls[
      'meetGreetSessionsNoOfPrograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'meetGreetSessionsImagefile'
    ].updateValueAndValidity();
  }
  // new 9th qus
  Options13checked = '';
  /**
   * Handles the change event of the "Has the institution formed a strategic alliance with industry partners" question.
   * @param event The change event.
   * @param val The value of the question.
   * @param i The index of the question in the form array.
   * @param set The form control for the question.
   */
  showOptions13(event, val, i, set) {
    this.Options13checked = event;
    if (event == 'No') {
      // If the answer is "No", remove any existing file and clear the validators for the question.
      this.removeFile(val, i, set);
      this.settingsForm.controls['strategicAllianceNoOfAlliances'].setValue('');
      this.settingsForm.controls['strategicAllianceImagefile'].setValue('');
      this.settingsForm.controls[
        'strategicAllianceNoOfAlliances'
      ].clearValidators();
      this.settingsForm.controls[
        'strategicAllianceImagefile'
      ].clearValidators();
    } else {
      // If the answer is "Yes", set the validators for the question.
      this.settingsForm.controls[
        'strategicAllianceNoOfAlliances'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['strategicAllianceImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form control.
    this.settingsForm.controls[
      'strategicAllianceNoOfAlliances'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'strategicAllianceImagefile'
    ].updateValueAndValidity();
  }
  /**
   * Handles the save button click event.
   * Validates the form, assigns document values if present, and submits the data to the API.
   * Displays notifications based on the result.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    if (this.settingsForm.invalid) {
      // Mark all form fields as touched and show an error notification if the form is invalid
      this.settingsForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Check and assign document values if they are not empty
      if (this.documentValues[0][0].documentFile != '') {
        getform.localStartupEcosystemDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.networkingPlatformDocuments = this.documentValues[1];
      }
      if (this.documentValues[2][0].documentFile != '') {
        getform.programsConductedDocuments = this.documentValues[2];
      }
      if (this.documentValues[3][0].documentFile != '') {
        getform.hostingLocalEntrepreneursDocuments = this.documentValues[3];
      }
      if (this.documentValues[4][0].documentFile != '') {
        getform.platformForStartupsDocuments = this.documentValues[4];
      }
      if (this.documentValues[5][0].documentFile != '') {
        getform.studentEntrepreneursDocuments = this.documentValues[5];
      }
      if (this.documentValues[6][0].documentFile != '') {
        getform.academicFinancialInstitutionsDocuments = this.documentValues[6];
      }
      if (this.documentValues[7][0].documentFile != '') {
        getform.externalMembersDocuments = this.documentValues[7];
      }
      if (this.documentValues[8][0].documentFile != '') {
        getform.facilitationOfIncubatedDocuments = this.documentValues[8];
      }
      // New 5th question
      if (this.documentValues[9][0].documentFile != '') {
        getform.databaseofPeopleEtcDocuments = this.documentValues[9];
      }
      // New 6th question
      if (this.documentValues[10][0].documentFile != '') {
        getform.conductLocalCommunityDocuments = this.documentValues[10];
      }
      // New 7th question
      if (this.documentValues[11][0].documentFile != '') {
        getform.meetGreetSessionsDocuments = this.documentValues[11];
      }
      // New 9th question
      if (this.documentValues[12][0].documentFile != '') {
        getform.strategicAllianceDocuments = this.documentValues[12];
      }

      // Show loader while making the API call
      this.getdata.amizhthLoader('show');

      // Make the API call to save the form data
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide loader after API call completes
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // Increment step, refresh data, and show success notification on success response
          this.step++;
          this.getDataApi();
          this.notify.notifysuccess(data.responseMessage);
        } else {
          // Show error notification on failure response
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Opens the guidelines modal for the given data
   * @param data - The data for which the guidelines modal should be opened
   */
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  /**
   * Retrieves the guidelines data from the JSON file
   */
  guidelineDatas() {
    /**
     * The HTTP GET request to retrieve the guidelines data
     */
    this.http.get('/assets/json/guideline.json').subscribe((data: any) => {
      /**
       * The guidelines data is stored in the `questions` array of the 5th index
       * of the `data` object
       */
      this.guidelineValue = data[5].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
